module.exports = __webpack_public_path__ + "static/media/Handbags_Thumb_1.f29c88c0.jpg";